import { render, staticRenderFns } from "./Members.vue?vue&type=template&id=79c320b6&lang=pug&"
import script from "./Members.vue?vue&type=script&lang=js&"
export * from "./Members.vue?vue&type=script&lang=js&"
import style0 from "./Members.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/rain/projects/themes/achernar/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('79c320b6')) {
      api.createRecord('79c320b6', component.options)
    } else {
      api.reload('79c320b6', component.options)
    }
    module.hot.accept("./Members.vue?vue&type=template&id=79c320b6&lang=pug&", function () {
      api.rerender('79c320b6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/Members.vue"
export default component.exports